import { render, staticRenderFns } from "./LinkedRecordFilterButton.vue?vue&type=template&id=544ee6e4&scoped=true"
import script from "./LinkedRecordFilterButton.vue?vue&type=script&lang=js"
export * from "./LinkedRecordFilterButton.vue?vue&type=script&lang=js"
import style0 from "./LinkedRecordFilterButton.vue?vue&type=style&index=0&id=544ee6e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ee6e4",
  null
  
)

export default component.exports